import { ComponentColor, ThemeColor } from '@/enums'
import { Typography } from '../Typography'
import { Container } from './styles'

interface BadgeProps {
  count: number | string
  color: ComponentColor
  size?: 'small' | 'medium' | 'large'
}

export const Badge = ({ count, color, size = 'large' }: BadgeProps) => {
  if (!count) return null

  return (
    <Container color={color} size={size}>
      <Typography color={ThemeColor.b0} variant="badgeText">
        {count}
      </Typography>
    </Container>
  )
}
